import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from "react";
import { DialogKey } from "../../dialogs/Dialogs";
import { PopUpsAPI, PopUpsData } from "../PopUp";
import { usePopUpsReducer } from "./PopUpsReducer";

//  CONTEXTS
export const PopUpsAPIContext = createContext({} as PopUpsAPI);
export const PopUpsDataContext = createContext({} as PopUpsData);

export const PopUpsProvider: FC<PropsWithChildren> = ({ children }) => {
  console.info("PopUpsProvider render");

  //  DATA REDUCER
  const { data, dispatch } = usePopUpsReducer();

  //  API
  const api = useMemo<PopUpsAPI>(() => {
    const openPopUp = (id: DialogKey) => {
      console.info("open the popup ", id);
      dispatch({ type: "setPopUpId", id });
      dispatch({ type: "setOpen", isOpen: true });
    };

    const closePopUp = () => {
      dispatch({ type: "setOpen", isOpen: false });
    };

    return {
      openPopUp,
      closePopUp,
    };
  }, [dispatch]);

  return (
    <PopUpsAPIContext.Provider value={api}>
      <PopUpsDataContext.Provider value={data}>
        {children}
      </PopUpsDataContext.Provider>
    </PopUpsAPIContext.Provider>
  );
};

//  CUSTOM HOOKS
export const usePopUpsAPI = () => useContext(PopUpsAPIContext);
export const usePopUpsData = () => useContext(PopUpsDataContext);
